import { render } from "./Comments.vue?vue&type=template&id=5b46213c&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"

import "./Comments.vue?vue&type=style&index=0&id=5b46213c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b46213c"

export default script